import gql from 'graphql-tag';

const monitoringDataFields = `
  year
  area
  overlapPercent
  criticalityRestriction
  restriction
`;

export const getSocioEnvironmentalData = gql`
  query socioEnvironmentalData($matriculaNumber: String!, $forceVegaReport: Boolean = false) {
    socioEnvironmentalData(matriculaNumber: $matriculaNumber, forceVegaReport: $forceVegaReport) {
      emissionDate
      registrationNumbers
      totalArea
      preservationArea
      complianceConflictArea
      biome
      cultivableArea
      ibamaEmbargo
      conservationUnities
      indigenousLand
      ICMBIOEmbargo
      stateEmbargo
      quilimbolasLand
      deforestationAfter2008
      permanentPreservationArea
      legalComments
      vegaReportDate
      state {
        id
        name
      }
      municipality {
        id
        name
      }
      prodes {
        ${monitoringDataFields}
      }
      deter  {
        ${monitoringDataFields}
      }
    }
  }
`;

export const getMatriculaHasTerritory = gql`
  query matriculaHasTerritory($matriculaNumber: String!) {
    matriculaHasTerritory(matriculaNumber: $matriculaNumber)
  }
`;
